import React, { useEffect, useState, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { UserStatusCssClasses, UserStatusTitles } from "../UsersUIHelpers";
import * as actions from "../../_redux/usersActions";
import { useUsersUIContext } from "../UsersUIContext";

const selectedUsers = (entities, ids) => {
  const _users = [];
  ids.forEach(id => {
    const user = entities.find(el => el.id === id);
    if (user) {
      _users.push(user);
    }
  });
  return _users;
};

export function UsersUpdateStateDialog({ show, onHide }) {
  // Users UI Context
  const UsersUIContext = useUsersUIContext();
  const UsersUIProps = useMemo(() => {
    return {
      ids: UsersUIContext.ids,
      setIds: UsersUIContext.setIds,
      queryParams: UsersUIContext.queryParams
    };
  }, [UsersUIContext]);

  // Users Redux state
  const { users, isLoading } = useSelector(
    state => ({
      users: selectedUsers(
        state.users ? state.users.entities : [],
        UsersUIProps.ids
      ),
      isLoading: state.users ? state.users.actionsLoading : false
    }),
    shallowEqual
  );

  // if !id we should close modal
  useEffect(() => {
    if (!UsersUIProps.ids || UsersUIProps.ids.length === 0) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [UsersUIProps.ids]);

  const [status, setStatus] = useState(0);

  const dispatch = useDispatch();
  const updateStatus = () => {
    // server request for update Users status by selected ids
    dispatch(actions.updateUsersStatus(UsersUIProps.ids, status)).then(() => {
      // refresh list after deletion
      dispatch(actions.fetchUsers(UsersUIProps.queryParams)).then(() => {
        // clear selections list
        UsersUIProps.setIds([]);
        // closing delete modal
        onHide();
      });
    });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Status has been updated for selected Users
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="overlay overlay-block cursor-default">
        {/*begin::Loading*/}
        {isLoading && (
          <div className="overlay-layer">
            <div className="spinner spinner-lg spinner-primary" />
          </div>
        )}
        {/*end::Loading*/}
        <table className="table table table-head-custom table-vertical-center overflow-hidden">
          <thead>
            <tr>
              <th>ID</th>
              <th>STATUS</th>
              <th>User</th>
            </tr>
          </thead>
          <tbody>
            {users.map(user => (
              <tr key={`id${user.id}`}>
                <td>{user.id}</td>
                <td>
                  <span
                    className={`label label-lg label-light-${
                      UserStatusCssClasses[user.status]
                    } label-inline`}
                  >
                    {" "}
                    {UserStatusTitles[user.status]}
                  </span>
                </td>
                <td>
                  <span className="ml-3">
                    {user.name}, {user.email}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Modal.Body>
      <Modal.Footer className="form">
        <div className="form-group">
          <select
            className="form-control"
            value={status}
            onChange={e => setStatus(+e.target.value)}
          >
            <option value="1">Active</option>
            <option value="2">InActive</option>
          </select>
        </div>
        <div className="form-group">
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate mr-3"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={updateStatus}
            className="btn btn-primary btn-elevate"
          >
            Update Status
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
